import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setRoutes } from "../redux/routes/routes.slice";

export const useBackHandler = ({ isPreventBack } = { isPreventBack: true }) => {
	const userRoutes = useSelector((state) => {
		return state?.router?.routes ?? [];
	});

	const location = useLocation();

	const dispatch = useDispatch();

	const navigate = useNavigate();

	const manualBack = useCallback(() => {
		const routes = Array.isArray(userRoutes) ? [...userRoutes] : [];
		routes.pop();

		const latestRoute = routes[routes.length - 1];

		dispatch(setRoutes(routes));

		if (latestRoute) {
			navigate(latestRoute.pathname);
		} else {
			navigate("/");
		}
	}, [dispatch, navigate, userRoutes]);

	useEffect(() => {
		const routes = Array.isArray(userRoutes) ? [...userRoutes] : [];

		const latestRoute = routes[routes.length - 1];

		if (latestRoute?.pathname !== location.pathname) {
			dispatch(setRoutes([...routes, location]));
		}
	}, [location, dispatch]);

	useEffect(() => {
		const preventBack = (event) => {
			window.history.pushState(null, document.title, window.location.href);
			event.preventDefault();
			return;
		};

		window.removeEventListener("popstate", preventBack);

		if (isPreventBack) {
			window.history.pushState(null, document.title, window.location.href);
			window.addEventListener("popstate", preventBack);
		}

		return () => {
			window.removeEventListener("popstate", preventBack);
		};
	}, [location]);

	return {
		manualBack,
	};
};
